<template>
  <div>
    <div class="promotion">
      <template v-if="form['id']">
        <el-form-item :label="language('promotionRules.createDate')">
          <div class="input">{{ form["createTime"] }}</div>
        </el-form-item>
        <el-form-item :label="language('promotionRules.promotionId')">
          <div class="input">{{ form["id"] }}</div>
        </el-form-item>
      </template>
      <el-form-item
        :label="language('promotionRules.activityUrl')"
        prop="imageUrl"
      >
        <cc-uploader
          :config="uploaderConf"
          v-model="form['imageUrl']"
          fType="image"
          :info="language('common.uploaderInfo')"
          :fFormatV2="['.png', '.jpg']"
        />
      </el-form-item>
      <el-form-item
        :label="language('promotionRules.activityName')"
        prop="activityName"
      >
        <div class="input">
          <el-input v-model="form['activityName']"></el-input>
        </div>
      </el-form-item>

      <!-- <el-form-item
        :label="language('promotionRules.promotionType')"
        prop="activityType"
      >
        <div class="input">
          {{ form["activityType"] }} -->
      <!-- <el-select v-model="form['activityType']" placeholder="">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
      <!-- </div>
      </el-form-item> -->
      <!-- <el-form-item
        :label="language('promotionRules.startTime')"
        prop="startTime"
      >
        <div class="input">
          <el-date-picker
            v-model="form['startTime']"
            type="datetime"
            placeholder=""
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item :label="language('promotionRules.endTime')" prop="endTime">
        <div class="input">
          <el-date-picker
            v-model="form['endTime']"
            type="datetime"
            placeholder=""
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
          >
          </el-date-picker>
        </div>
      </el-form-item> -->

      <el-form-item
        :label="language('promotionRules.promotionTime')"
        prop="promotionTime"
      >
        <div class="input">
          <el-date-picker
            v-model="form['promotionTime']"
            type="datetimerange"
            placeholder=""
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
      </el-form-item>

      <el-form-item :label="language('promotionRules.status')" prop="status">
        <div class="input">
          <el-radio v-model="form['status']" :label="0">{{
            language("promotionRules.off")
          }}</el-radio>
          <el-radio v-model="form['status']" :label="1">{{
            language("promotionRules.on")
          }}</el-radio>
        </div>
      </el-form-item>
      <template v-if="form['id']">
        <el-form-item :label="language('promotionRules.lastUpdated')">
          <div class="input">{{ form["updateTime"] }}</div>
        </el-form-item>
        <el-form-item :label="language('promotionRules.lastUpdatedBy')">
          <div class="input">{{ form["updateAdminName"] }}</div>
        </el-form-item>
      </template>
    </div>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";

export default {
  props: {
    formData: Object,
  },
  data() {
    return {
      uploaderConf: uploadUtils.configPublish,

      form: {},
      options: [
        {
          value: "flashSale",
          label: "BasicDiscounts", //限時促銷
        },
        {
          value: "buyMoreGetMore",
          label: "BuyMoreGetMore", //多買多折
        },
        {
          value: "MChooseN",
          label: "FixedPriceInQty", //M選N
        },
      ],
    };
  },
  watch: {
    form: {
      handler() {
        let url = "/perm/marketing/";
        if (this.form.id) {
          url = "/perm/marketing/" + this.form.id + "/";
        }
        this.uploaderConf =uploadUtils.configPublishV2(url);
        // console.log(this.uploaderConf)

        let data = {
          ...this.form,
        };
        this.$emit("change", data);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    console.log(this.formData, "this.formDatathis.formDatathis.formData");
    this.form = { ...this.formData };
    // this.form.promotionTime = [this.form.startTime, this.form.endTime];
    if (this.form.status == 2) {
      this.form.status = "";
    }
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
</style>
<style lang="scss">
.promotion {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>
